import { z } from "zod";
import { MIN_PASSWORD_LENGTH, ROLES } from "../constants.js";
import { idSchema } from "../primitives.js";

export const signInInput = z.object({
  email: z.email(),
  password: z.string().min(1),
  turnstileToken: z.string().min(1),
});

export const acceptInviteInput = z.object({
  password: z.string().min(MIN_PASSWORD_LENGTH, `비밀번호는 ${MIN_PASSWORD_LENGTH}자 이상이어야 합니다`).max(200),
  turnstileToken: z.string().min(1),
});

export const createInviteInput = z
  .object({
    email: z.email(),
    name: z.string().min(1).max(100),
    role: z.enum(ROLES),
    restaurantId: idSchema.nullish(),
    supplierId: idSchema.nullish(),
  })
  .refine(
    (v) =>
      (v.role === "restaurant" && !!v.restaurantId && !v.supplierId) ||
      (v.role === "supplier" && !!v.supplierId && !v.restaurantId) ||
      (v.role === "admin" && !v.restaurantId && !v.supplierId),
    { message: "역할과 소속 조직이 일치하지 않습니다", path: ["role"] },
  );

export type CreateInviteInput = z.infer<typeof createInviteInput>;
